<script>

	import { Accordion, AccordionItem } from '@sveltestrap/sveltestrap';
  	import ShowTN from './components/showTN.svelte';
	let RANKING={};

	let promise = getRANKING()

	function setMinTN(rnk) {
		rnk.joueurs.forEach(j => {
			let min =100
			let notAllTN = false
			// let tot = 0

			j.TNs.forEach(t => {
				if (t.points<min && t.points>0) min = t.points 
				if (t.points=="-") notAllTN=true
			})
			// console.log(min)
			let found = false
			j.TNs.forEach(t => {
				if (t.points==min && !found && !notAllTN) 
					{t.min = 1; found = true}
				else
					{t.min = 0; 
						// t.points!="-" ? tot += parseFloat(t.points) : tot+=0
					}
			}) 
			// j.tot=tot
			// console.log(j.TNs)
		});
			
		return rnk
	}
	
	async function getRANKING() {
		// console.log('get: ' + selComp + "/" + curComp)
		const res = await fetch('https://5quilles.ffbillard.com/RANKING/PHP/getRANKING.php')
		const json = await res.json();
		const jsonres= setMinTN(json)
		console.log(jsonres)
		return jsonres
	}

</script>

<main>

	{#await promise}
		<div style ="display:flex; justify-content:center; align-items:center; min-height:100vh">
			<div class="spinner-border text-success" style="width: 3rem; height: 3rem;" role="status">
				<span class="visually-hidden">Loading...</span>
	 		</div>
		</div>
	{:then RANKING}
		<nav class="navbar sticky-top" style="background-color:darkorange;">
			<div class="container-fluid" style="align-items: middle">
				
						<h2 style="width:100%; text-align: center; color:white" >
							Ranking 5 Quilles
						</h2>
						<h4 style="width:100%; text-align: center; color:white" >
							{RANKING.ranking}
						</h4>
				
			</div>
		</nav>

			<br>
			
		
			<Accordion style="padding:8px" >
				{#each RANKING.joueurs as p, j}
					<AccordionItem>
						<h5 style="font-size:0.8em" class="m-0" slot="header">{j+1} - {p.nom} - {p.points.toFixed(4)}</h5>
							{#each p.TNs as t, k}
									{#if k>0}
										<hr>
									{/if}
									<ShowTN TN={t} ></ShowTN>
							{/each}
					</AccordionItem>
				{/each}
			</Accordion>
			
	{/await} 
	 
</main>

<style>
	

	hr {
		margin-top : 0.3rem;
		margin-bottom : 0.5rem;
	 }

</style>